<template>
    <div class="car-quote-step car-info">
        <quote-step-header
            :key="currentSubStep"
            :subtitle="subStepFields.subtitle"
            :title="subStepFields.title"
        ></quote-step-header>

        <form class="quote-form" @submit.prevent="next">
            <div class="form-row center">
                <div class="car-system w-full">
                    <div
                        :class="{ invalid: carName === false }"
                        class="car-license-input"
                    >
                        <div class="license-input-wrap">
                            <app-box-input
                                v-model="form[stepName]['car'].licencePlate"
                                :full="true"
                                :message="errors.get('licencePlate')"
                                label="licensePlate"
                                placeholder="quote.car.enter_plate"
                                @input="searchLicensePlate"
                            ></app-box-input>

                            <div
                                v-if="loadCar"
                                class="load-car"
                                v-html="$icon('loader')"
                            ></div>

                            <div
                                v-if="!loadCar && carName && carName.length"
                                class="vi-icon"
                            >
                                <svg
                                    fill="none"
                                    height="68"
                                    viewBox="0 0 67 68"
                                    width="67"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        height="37.4667"
                                        stroke="#185AF5"
                                        stroke-width="2.73333"
                                        width="58.3111"
                                        x="4.34323"
                                        y="15.2671"
                                    />
                                    <path
                                        d="M63.8594 13.0625H3.14062C1.98592 13.0625 1.04688 14.0015 1.04688 15.1562V52.8438C1.04688 53.9985 1.98592 54.9375 3.14062 54.9375H63.8594C65.0141 54.9375 65.9531 53.9985 65.9531 52.8438V15.1562C65.9531 14.0015 65.0141 13.0625 63.8594 13.0625ZM63.8562 52.8438H3.14062V15.1562H63.8594L63.8562 52.8438Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M61.7656 17.25H5.23438V50.75H61.7656V17.25ZM59.6719 48.6562H7.32812V19.3438H59.6719V48.6562Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M57.5781 21.4375H55.4844V23.5312H57.5781V21.4375Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M11.5156 21.4375H9.42188V23.5312H11.5156V21.4375Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M57.5781 44.4688H55.4844V46.5625H57.5781V44.4688Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M11.5156 44.4688H9.42188V46.5625H11.5156V44.4688Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M10.4688 36.0938C10.4688 37.4798 11.011 38.7936 12.0056 39.8018C13.0043 40.7858 14.3181 41.3281 15.7031 41.3281C18.5894 41.3281 20.9375 38.98 20.9375 36.0938H18.8438C18.8438 37.8253 17.4347 39.2344 15.7031 39.2344C14.8709 39.2344 14.0794 38.9067 13.4858 38.3215C12.8902 37.7175 12.5625 36.926 12.5625 36.0938V31.9062C12.5625 30.1747 13.9716 28.7656 15.7031 28.7656C16.5354 28.7656 17.3268 29.0933 17.9204 29.6785C18.5161 30.2825 18.8438 31.074 18.8438 31.9062H20.9375C20.9375 30.5202 20.3952 29.2064 19.4007 28.1982C18.402 27.2142 17.0881 26.6719 15.7031 26.6719C12.8169 26.6719 10.4688 29.02 10.4688 31.9062V36.0938Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M29.3125 32.9531H23.0312V35.0469H29.3125V32.9531Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M35.5938 29.8125V31.9062C35.5938 32.4831 35.1248 32.9531 34.5469 32.9531H31.4062V35.0469H34.5469C35.1248 35.0469 35.5938 35.5169 35.5938 36.0938V38.1875C35.5938 38.7643 35.1248 39.2344 34.5469 39.2344H29.3125V41.3281H34.5469C36.2784 41.3281 37.6875 39.919 37.6875 38.1875V36.0938C37.6875 35.2866 37.3724 34.5569 36.8709 34C37.3734 33.4431 37.6875 32.7134 37.6875 31.9062V29.8125C37.6875 28.081 36.2784 26.6719 34.5469 26.6719H29.3125V28.7656H34.5469C35.1248 28.7656 35.5938 29.2357 35.5938 29.8125Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M48.1562 39.2344H42.3084L46.3734 35.1694C47.5061 34.0366 48.1562 32.4653 48.1562 30.8594C48.1562 29.7424 47.7207 28.6913 46.9283 27.8999C46.1368 27.1084 45.0847 26.6719 43.9688 26.6719C41.6593 26.6719 39.7812 28.55 39.7812 30.8594V31.9062H41.875V30.8594C41.875 29.7047 42.814 28.7656 43.9688 28.7656C44.5257 28.7656 45.0512 28.9834 45.448 29.3801C45.8447 29.7769 46.0625 30.3014 46.0625 30.8594C46.0625 31.9146 45.6364 32.9458 44.8931 33.6891L39.7812 38.801V41.3281H48.1562V39.2344Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M56.5312 39.2344H54.4375V26.6719H50.25V28.7656H52.3438V39.2344H50.25V41.3281H56.5312V39.2344Z"
                                        fill="black"
                                    />
                                </svg>
                            </div>

                            <div
                                v-if="!loadCar && carName === false"
                                class="vi-icon"
                            >
                                <svg
                                    height="12.863"
                                    viewBox="0 0 12.863 12.863"
                                    width="12.863"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        id="close"
                                        d="M12.863 1.516L11.347 0 6.432 4.916 1.516 0 0 1.516l4.916 4.916L0 11.348l1.516 1.516 4.916-4.917 4.916 4.916 1.516-1.516-4.917-4.915z"
                                        fill="#ff4a4a"
                                    />
                                </svg>
                            </div>
                        </div>

                        <div v-if="carName && carName.length" class="car-name">
                            {{ carName }}
                        </div>

                        <div
                            v-if="carName === false"
                            class="car-name"
                            v-html="trans('car_not_found')"
                        ></div>
                    </div>

                    <transition name="slide-fade">
                        <div
                            v-if="safety && carName && carName.length"
                            class="car-found"
                        >
                            <div class="icon">
                                <svg
                                    fill="none"
                                    height="36"
                                    viewBox="0 0 36 36"
                                    width="36"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clip-path="url(#clip0_1145_1753)">
                                        <path
                                            d="M2.25 33.75C2.25 34.9945 3.25617 36 4.5 36H15.75V20.25H2.25V33.75ZM33.75 9H30.787C31.628 7.38844 31.8424 5.4457 30.7842 3.27656C29.7703 1.19461 27.6047 -0.00109612 25.2773 7.53998e-07C22.3383 0.00109763 20.4398 1.49906 18 4.80234C15.5602 1.49906 13.6617 0.00109763 10.7227 7.53998e-07C8.39531 -0.00109612 6.23109 1.19461 5.21578 3.27656C4.15758 5.4457 4.37203 7.38984 5.21367 9H2.25C1.00758 9 0 10.0076 0 11.25V15.75C0 16.9875 1.0125 17.9979 2.18672 17.9979H33.6867C34.9242 17.9979 35.9367 16.9875 35.9367 15.75V11.25C36 10.0055 34.9945 9 33.75 9ZM10.8211 9C9.26789 9 8.00859 7.7407 8.00859 6.1875C8.00859 4.6343 9.26789 3.375 10.8211 3.375C12.2203 3.375 13.2539 3.60703 16.875 9H10.8211ZM25.1789 9H19.125C22.7461 3.60703 23.779 3.375 25.1782 3.375C26.7314 3.375 27.9907 4.6343 27.9907 6.1875C27.9907 7.7407 26.7328 9 25.1789 9ZM20.25 36H31.5C32.7438 36 33.75 34.9945 33.75 33.75L33.75 20.25H20.3133L20.25 36Z"
                                            fill="#185AF5"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1145_1753">
                                            <rect
                                                fill="white"
                                                height="36"
                                                width="36"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <p v-html="trans('car_has_safety')"></p>
                        </div>
                    </transition>
                    <div
                        v-if="carName && carName.length"
                        class="row-item mt-8 lg:mb-0"
                    >
                        <div class="row-item-title">
                            {{ trans("is_private") }}
                        </div>
                        <app-text-radio-buttons
                            v-model="form[stepName].privateOwnership"
                            :message="errors.get('privateOwned')"
                            :items="quoteStepThree"
                        >
                        </app-text-radio-buttons>
                    </div>
                </div>

                <!--We will need this at later steps dont delete <template v-if="subStep === 'shiabud'">
                    <div class="shiabud-items-wrap">
                        <div class="shiabud-toggle">
                            <app-text-radio-buttons
                                v-model="form[stepName].shiabud"
                                :message="errors.get('row')"
                                :items="shiabudItems"
                            >
                            </app-text-radio-buttons>
                        </div>

                        <div class="shiabud-wrap">
                            <app-box-input
                                v-if="
                                    form[stepName].shiabud &&
                                        form[stepName].shiabud !== 'none'
                                "
                                placeholder="quote.car.enter_bank"
                                :message="errors.get('shiabud_bank')"
                                v-model="form[stepName].shiabud_bank"
                            ></app-box-input>

                            <app-box-input
                                v-if="
                                    form[stepName].shiabud &&
                                        form[stepName].shiabud === 'bank'
                                "
                                placeholder="quote.car.enter_branch"
                                :message="errors.get('shiabud_branch')"
                                v-model="form[stepName].shiabud_branch"
                            ></app-box-input>
                        </div>
                    </div>
                </template> -->
            </div>

            <div class="submit-row mt-8">
                <app-button
                    :disabled="disabledConditions || loadCar"
                    :loading="loading"
                >
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";

export default {
    name: "CarQuoteCarInfo",

    mixins: [QuoteStep],

    props: {},

    data() {
        return {
            subSteps: ["default"],
            searchingLicense: false,
            licenseFound: false,
            hasSafety: false,
            carName: null,
            licenseLookupTimeout: null,
            loadCar: false,
            safety: false
        };
    },

    computed: {
        quoteStepOne() {
            return [
                {
                    label: this.$trans("quote.car.yes"),
                    value: true
                },
                {
                    label: this.$trans("quote.car.no"),
                    value: false
                }
            ];
        },
        quoteStepTwo() {
            return [
                {
                    label: this.$trans("quote.car.yes"),
                    value: true
                },
                {
                    label: this.$trans("quote.car.no"),
                    value: false
                }
            ];
        },
        quoteStepThree() {
            return [
                {
                    label: this.$trans("quote.car.yes"),
                    value: true
                },
                {
                    label: this.$trans("quote.car.no"),
                    value: false
                }
            ];
        },
        homeCoverage() {
            return [
                {
                    label: this.trans("types.all"),
                    value: this.constants.COVERAGE_ALL
                },
                {
                    label: this.trans("types.structure"),
                    value: this.constants.COVERAGE_CONTENT
                },
                {
                    label: this.trans("types.content"),
                    value: this.constants.COVERAGE_STRUCTURE
                }
            ];
        },
        shiabudItems() {
            return [
                {
                    label: this.$trans("quote.car.bank"),
                    value: "bank"
                },
                {
                    label: this.$trans("quote.car.other"),
                    value: "other"
                },
                {
                    label: this.$trans("quote.car.no"),
                    value: "none"
                }
            ];
        },
        canMoveNext() {
            switch (this.subStep) {
                case "safety": {
                    return (
                        this.carName !== false &&
                        this.form[this.stepName]["car"].licencePlate &&
                        this.form[this.stepName]["car"].licencePlate.toString()
                            .length >= 7
                    );
                }
                case "safety_check": {
                    return (
                        this.stepFormFields["car"].LDW !== null &&
                        this.stepFormFields["car"].FCW !== null &&
                        this.stepFormFields["car"].privateOwnership !== null
                    );
                }
                case "shiabud": {
                    return true;
                }
            }

            return true;
        }
    },

    async mounted() {
        this.$nextTick(async () => {
            if (this.currentSubStep === 0) {
                await this.searchLicensePlate();
            }
        });
    },

    watch: {
        async currentSubStep(subStep) {
            if (subStep === 0) {
                await this.searchLicensePlate();
            }
        }
    },

    methods: {
        async searchLicensePlate() {
            if (
                !this.form[this.stepName]["car"].licencePlate ||
                this.form[this.stepName]["car"].licencePlate.length < 7
            ) {
                this.carName = null;
                return;
            }

            if (this.licenseLookupTimeout) {
                clearTimeout(this.licenseLookupTimeout);
            }
            this.loadCar = true;
            this.licenseLookupTimeout = setTimeout(async () => {
                this.searchingLicense = true;
                const licensePlate = this.form[this.stepName]["car"]
                    .licencePlate;
                let response = await this.$api.getTemp(
                    `car/search/${licensePlate}`
                );
                this.licenseFound = response.data().exists;
                this.loadCar = false;

                if (this.licenseFound) {
                    this.carName = response.data().car.name;
                    this.safety = response.data().car.hasSafety;

                    const carData = response.data().car.carData;

                    this.form[this.stepName]["car"] = {
                        ...this.form[this.stepName]["car"],
                        ...carData,
                        ...{ licencePlate: licensePlate }
                    };
                } else {
                    this.carName = false;
                    this.safety = false;
                    return;
                }

                this.searchingLicense = false;
            }, 500);
        }
    }
};
</script>

<style lang="scss" scoped>
.car-info {
    max-width: $quote-step-width;
}
.shiabud-items-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: $mobile) {
        width: 100%;
    }

    .shiabud-wrap {
        display: flex;
        margin-top: 15px;
        width: 100%;
        justify-content: space-between;

        @media screen and (max-width: $mobile) {
            flex-direction: column;
        }

        .app-box-input {
            width: 48%;

            @media screen and (max-width: $mobile) {
                margin-bottom: 15px;
                width: 100%;
            }
        }
    }

    .app-box-input {
        margin-top: 15px;
        width: 100%;

        .box-input-wrap {
            width: 100% !important;
            border: none !important;
            border-bottom: 1px solid $medium-gray !important;
            height: 45px !important;

            input {
                text-align: right !important;
                font-size: 19px;

                &:focus {
                    border: none !important;
                    border-bottom: solid 1px $primary-blue !important;
                }
            }
        }
    }
}

.car-license-input {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    max-width: 830px;
    width: 100%;
    margin: 0 auto;
    flex-direction: column;
    gap: 30px;

    @media all and (max-width: $mobile) {
        flex-direction: column;
    }

    .license-input-wrap {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;

        ::v-deep {
            .app-box-input {
                width: 100%;

                input {
                    width: 75%;
                    text-align: center;
                    padding: 10px;
                }

                .box-input-wrap {
                    width: 100%;
                }
            }
        }
    }

    &.invalid {
        .app-box-input {
            input {
                color: $error-red;
                border: solid 1px $error-red;

                &:focus {
                    color: $error-red;
                    border: solid 1px $error-red;
                }
            }
        }

        .car-name {
            color: $error-red;
        }
    }

    .car-name {
        font-size: 25px;
        font-weight: $font-light;
        padding-right: 10px;
        //max-width: 300px;

        @media all and (max-width: $mobile) {
            font-size: 20px;
            margin-top: 22px;
            padding-right: 0;
            max-width: 100%;
        }
    }
}

.car-safety-check-wrap {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    margin-bottom: 35px;
}

.car-safety-check {
    display: flex;
    flex-direction: column;

    font-size: 20px;
    font-weight: $font-light;
    letter-spacing: 0.8px;
    color: $black;

    .app-car-checkbox-buttons:not(:last-child) {
        margin-bottom: 15px;
    }

    .app-car-checkbox-buttons:not(:last-child):not(.has-message) {
        margin-bottom: 35px;
    }
}

.step-car-safety-check {
    display: flex;
    flex-direction: column;

    font-size: 20px;
    font-weight: $font-light;
    letter-spacing: 0.8px;
    color: $black;

    .app-car-checkbox-buttons:not(:last-child) {
        margin-bottom: 15px;
    }

    .app-car-checkbox-buttons:not(:last-child):not(.has-message) {
        margin-bottom: 35px;
    }

    .car-safety-check-wrap label {
        font-size: 20px;
        font-weight: $font-light;
        line-height: 33px;
        color: $black;
        text-align: center;
        z-index: 1;
        transition: all 0.2s ease-in-out;
        width: 100px !important;
        height: 44px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid $medium-gray;
    }

    .app-quote-radio-buttons {
        position: relative;
        cursor: pointer;
        margin-right: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.car-found {
    display: flex;
    gap: 30px;
    align-items: center;
    margin-top: 40px;
    text-align: center;
    padding: 15px 50px;

    border-radius: 5px;
    background: rgb(24, 90, 245, 0.1);

    @media screen and (max-width: $mobile) {
        flex-direction: column;
        gap: 10px;
    }

    p {
        color: var(--blue, $primary-blue);
        text-align: right;
        font-size: 16px;
        font-weight: $font-semi-bold;

        @media screen and (max-width: $mobile) {
            text-align: center;
        }
    }
}

.vi-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 100px;
    z-index: 9;

    @media screen and (max-width: $mobile) {
        display: none;
    }
}

.load-car {
    display: flex;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 15px;
    z-index: 9;

    svg {
        width: 30px;
        height: 30px;
        fill: $primary-blue;
        stroke: $primary-blue;
    }
}
</style>
